var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.directionArrows},_vm._l((_vm.directions),function(direction){return _c('button',{key:direction.id,class:[
      _vm.$style.directionArrows__button,
      _vm.$style[("directionArrows__button--" + direction)] ],on:{"click":function($event){return _vm.onClick(direction)}}},[_c('span',{class:[_vm.$style.arrowIcon, _vm.$style[("arrowIcon--" + direction)]]})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }